<template>
  <div>
    <SurveyComponent v-if="survey" :model="survey" />
  </div>
</template>

<script>
import {LicenseEditorModel} from "@/models/LicenseEditorModel";
import {SurveyComponent} from "survey-vue3-ui";
import SurveyModel from "@/models/SurveyModel";

export default {
  components: {SurveyComponent},
  emits: ['completed'],
  props: {
    model: LicenseEditorModel,
    readOnly: Boolean
  },
  data() {
    return {
      survey: null
    };
  },
  mounted() {
    const profilePrefix = `[CustomRegistrationForm ${this.model?.id || 'new'}]`;
    console.time(`${profilePrefix} create survey`);
    this.survey = SurveyModel.createFromLicenseEditor(this.model, {
      editable: !this.readOnly,
      disableFileUploads: !this.model.isNew,
      onUpdated: () => this.updateStatus()
    });
    console.timeEnd(`${profilePrefix} create survey`);

    console.time(`${profilePrefix} initial updateStatus`);
    this.updateStatus();
    console.timeEnd(`${profilePrefix} initial updateStatus`);
  },
  methods: {
    updateStatus() {
      // Use the same recursive validation as submission, including nested panels,
      // conditional requirements and validators, without showing errors on load.
      this.model.isCustomComplete = this.survey?.validate(false, false) === true;
    }
  }
}
</script>

<style>
.sd-page__row.sd-row--compact {
  margin-top: 0 !important;
}
.sd-root-modern .sd-container-modern .sd-body, .sd-root-modern .sd-container-modern .sd-body .sd-page {
  gap: 1rem !important;
}
.sd-question__header--location-top {
  padding-bottom: 0 !important;
  font-size: 16px;
  margin-bottom: 0.5rem;
  font-weight: 500;
}
.sd-description.sd-question__description {
  margin-top: 0;
}
.sd-element__title span {
  color: var(--bs-modal-color);
}
</style>
